/**
 * by_name: 名前でソート
 * asc_created: プレイリストの作成日(昇順)
 * desc_created: プレイリストの作成日(降順)
 */
export const PLAY_LIST_SORT_LIST = ['by_name', 'desc_created', 'asc_created'] as const

export type PlayListSortType = typeof PLAY_LIST_SORT_LIST[number]

export const PLAY_LIST_SORT_LOCAL_STORAGE_KEY = 'play_list_sort_local_storage_key'
